import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import { IconMegaphone } from '~/ui/core/icons';

import { useNavigationMenu } from '../app/app-bar/menu-bar-v2/NavigationMenuContext';
import { useAnnouncements } from './AnnouncementsContext';

export const AnnouncementsMegaphone: FunctionComponent = () => {
    const { isExpanded, shouldContentOverflow } = useNavigationMenu();
    const translate = useTranslate();
    const { history, openModal } = useAnnouncements();
    const shouldShowExpandedLayout = isExpanded || shouldContentOverflow;

    if (is.undefined(history) || is.emptyArray(history)) {
        return null;
    }

    const hasUndismissed = history.some((item) => !item.dismissed);

    return (
        <Button
            aria-label={translate('announcements.whats_new')}
            className="w-full justify-start overflow-hidden p-l! text-left focus-visible:outline focus-visible:outline-1 focus-visible:outline-orange-800"
            iconOnly={!shouldShowExpandedLayout}
            iconPosition="leading"
            variant="tertiary"
            onClick={openModal}
        >
            <div className="relative flex items-center text-gray-600">
                <IconMegaphone size="1rem" />
                {hasUndismissed && <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-error-500 rounded-full" />}
            </div>
            <span
                className={`flex flex-1 min-w-0 whitespace-nowrap text-sm font-medium leading-none text-gray-800 transition-opacity duration-[400ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${isExpanded ? 'opacity-100' : 'opacity-0'}`}
            >
                {translate('announcements.whats_new')}
            </span>
        </Button>
    );
};
